package com.milta.feature.profile.domain.entity

data class ProfileEntity(
    val accountId: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val language: String?,
    val roles: List<String>,
)
